import styled from 'styled-components';
import { Button } from 'antd';
import { Building } from '@styled-icons/fa-regular/Building';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .hefesto-modal__container__body-container {
    overflow: initial;
  }
`;

export const Subtitle = styled.span`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.grayDark4};
  font-family: ${({ theme }) => theme.fonts.workSans};
`;

export const NewConstructionRedirectButton = styled(Button)`
  display: flex;
  align-items: center;
  margin-left: auto;
  height: 3rem;
`;

export const BuildingIcon = styled(Building)`
  width: 0.75rem;
  margin-right: 0.5rem;
`;
